import { CONTACT_STANDARD_FIELD_IDS } from "components/Event/Contacts/constants";
import getValue from "utils/value-types/get-value/text";
import { get } from "lodash";

const { email } = CONTACT_STANDARD_FIELD_IDS;
export default values =>
  getValue(get(values.find(({ field_id }) => field_id === email), "value"));
